import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { format } from '@dt/fe-utils'
import { payPlanMobx } from '@mobx/mall/payment'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { KeyBoard } from '@cps'
import CannotPayTip from '@pages/checkout/component/Pay/CannotPayTip'
import './index.scss'

interface IProps {
  card: IMemberGiftCardInfo;
  resolve?: (amount: number) => void;
  reject?: () => void;
  firstNum?: number;

}

const GiftCardAmountModal: FC<IProps> = ({ card, firstNum, resolve, reject }) => {
  const initailNum: number = card.balance > Number(firstNum) ? firstNum : card.balance
  const [amountStr, setAmountStr] = useState<string>(initailNum.toFixed(2))
  const [amount, setAmount] = useState<number>(0)

  useEffect(() => {
    try {
      const amount = parseFloat(amountStr)
      setAmount(amount)
      if (amount > card.balance) {
        setAmountStr(card.balance.toFixed(2))
      }
      if (card.giftcard.isPayTip) {
        if (amount > payPlanMobx.totalAmount) {
          setAmountStr(payPlanMobx.totalAmount.toFixed(2))
        }
      } else {
        const nonTipAmount = payPlanMobx.totalAmount - payPlanMobx.tipAmount
        if (amount > nonTipAmount) {
          setAmountStr(nonTipAmount.toFixed(2))
        }
      }
    } catch { }
  }, [amountStr])

  const canSubmit = amount >= 0

  const submit = () => {
    resolve && resolve(amount)
  }

  return (
    <IonModal
      isOpen
      cssClass='mall-gift-card-amount-modal height620-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='gift-card-amount-header'>
          <i className='iconfont icon-huiyuanka' />
          <div className='card-info'>
            {i18n.t(
              'pay.giftCardDisplay', {
                name: card.giftcard.giftcardName || i18n.t('pay.giftCard'),
                cardNo: format.shortCardNumber(card.cardNo)
              }
            )}
            {window.bo !== 'cn' && !card.giftcard.isPayTip && <CannotPayTip message={i18n.t('pay.giftCardCannotPayTip')} />}
            <div className='balance'>{i18n.t('pay.cardBalanceN', { n: format.toPrice(card.balance) })}</div>
          </div>
        </div>
      </IonHeader>
      <IonContent>
        <div className='amount'>{amountStr}</div>
        <div className='hint'>{i18n.t('pay.payThisTime')}</div>
        <KeyBoard value={amountStr} onChange={setAmountStr} />
      </IonContent>
      <IonFooter className='gift-card-amount-footer'>
        <button className='cancel-button' onClick={reject}>{i18n.t('common.cancel')}</button>
        <button className='submit-button' disabled={!canSubmit} onClick={submit}>{i18n.t('common.ok')}</button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(GiftCardAmountModal)
